/* istanbul ignore file -- api call */
import { useToken } from '@ori/auth';
import { useEnvironment } from '@ori/environment';
import { TENANT_CONTEXT } from '@ori/fetching';
import { createApplicationsNavigationSignal, useApiClient } from '@ori/global-api-client-react';
import { useLanguage } from '@ori/i18n';
import { useCallback } from 'react';

import { ACCEPT_LANGUAGE } from '../../../constants';
import { useSearchInput } from '../../../context/navigation';
import { analytics } from '../../../utils';

interface UseSendNavigationSignalParams {
  query: string;
}
export const useSendNavigationSignal = ({ query }: UseSendNavigationSignalParams) => {
  const { customerId } = useToken();
  const { results, timestamp } = useSearchInput();
  const globalApiClient = useApiClient();
  const { tenant } = useEnvironment();
  const { language } = useLanguage();
  const sendNavigationSignal = useCallback(
    async (position: number) => {
      if (!results) {
        return;
      }
      const analyticsData = analytics.getSignalsData({ customerId, position, results, timestamp, query });

      await createApplicationsNavigationSignal(globalApiClient, analyticsData, {
        [ACCEPT_LANGUAGE]: language,
        [TENANT_CONTEXT]: tenant,
      });
    },
    [results, customerId, timestamp, query, globalApiClient, language, tenant],
  );

  return { sendNavigationSignal };
};
